<!-- 活动/Banner 商品列表页面 -->
<!-- 方案A：Banner + 扁平二级分类 Tab + 排序 + 商品列表 -->
<template>
  <div
    class="activity-goods-page"
    :class="{ 'has-theme': !!themeColor }"
    :style="pageThemeVars"
  >
    <div
      v-if="currentBannerUrl"
      class="activity-banner-section"
    >
      <van-image
        fit="cover"
        width="100%"
        height="100%"
        :src="currentBannerUrl"
        class="activity-banner-img"
      />
    </div>

    <!-- 分类 Tab + 排序：滚动后吸顶 -->
    <van-sticky :offset-top="0">
      <div class="activity-sticky-bar">
        <div
          v-if="showActivityTabs"
          class="activity-theme-zone"
          :class="{ 'has-theme': !!themeColor }"
          :style="themeZoneStyle"
        >
          <SecondTab
            class="second-tab-wrapper activity-flat-tabs"
            :title="activityTabList"
            ref="secondTab"
            @scrollTo="scrollTo"
          />
        </div>
        <SortFilter
          :priceType="form.priceType"
          @sort-default="setNomal"
          @sort-price="setPrictType"
        />
      </div>
    </van-sticky>

    <div class="activity-list-body" :style="listAreaStyle">
      <loading v-if="loading"></loading>
      <div v-else>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div v-if="list.length > 0">
            <van-list
              v-model="loading2"
              :finished="finished"
              finished-text="没有更多了"
              @load="nextPage"
            >
              <goods-list-com
                :DataList="list"
                :activity-id="activityId"
                :hot-type="hotType"
                :activity-feature-type="activityFeatureType"
              />
            </van-list>
          </div>
          <div v-else-if="!loading && !loading2" class="goods-empty">
            <span>暂无商品</span>
          </div>
        </van-pull-refresh>
      </div>
    </div>

    <div v-if="showBackTop" class="back-top-btn" @click="scrollToTop">
      <van-icon name="arrow-up" size="1.2rem" />
      <span>顶部</span>
    </div>
  </div>
</template>

<script>
import SecondTab from '../../components/goodlist/SecondTab.vue'
import SortFilter from '../../components/goodlist/SortFilter.vue'
import GoodsListCom from '../../components/GoodsListCom.vue'
import {
  getActivityListBackground,
  getCategorySectionBackgroundStyle,
} from '../../utils/themeColor'
import {
  PAGE_KEYS,
  SECTION_KEYS,
  consumePageViewState,
  getWindowScrollTop,
  isPageViewRestorePending,
  restorePageViewState,
  savePageViewState,
  shouldPreserveViewState,
} from '../../utils/pageScrollRestore'
let initViewfinish = false

export default {
  name: 'ActivityGoodsList',
  components: { SecondTab, SortFilter, GoodsListCom },
  data() {
    return {
      loading: false,
      loading2: false,
      finished: false,
      isLoading: false,
      showBackTop: false,
      dataLoaded: false,

      list: [],
      bannerList: [],
      /** 扁平化活动 Tab：{ id, name, category1Id, category2Id } */
      activityTabList: [],
      activeTabIndex: 0,

      activityId: '',
      hotType: '',
      showType: '',
      themeColor: '',
      activityFeatureType: '0',

      form: {
        cardId: '',
        current: 1,
        size: 10,
        category1Id: '',
        category2Id: '',
        cityCode: '',
        upgradeFlag: '',
        bathId: '',
        hotType: '',
        id: '',
        priceType: null,
      },
    }
  },
  computed: {
    /** 商品列表区浅 tint 背景（参考行业：白卡片 + 主题浅色底） */
    themeListBgColor() {
      if (!this.themeColor) return '#f5f5f5'
      return getActivityListBackground(this.themeColor, 0.88)
    },
    pageThemeVars() {
      if (!this.themeColor) return {}
      return {
        '--activity-theme-color': this.themeColor,
        '--activity-list-bg': this.themeListBgColor,
      }
    },
    /** 分类 Tab 区背景：与礼包首页一致，取主题色做 135deg 渐变 */
    themeZoneStyle() {
      return getCategorySectionBackgroundStyle(this.themeColor)
    },
    listAreaStyle() {
      return {
        backgroundColor: this.themeListBgColor,
        transition: 'background-color 0.4s ease',
      }
    },
    currentBannerUrl() {
      const banner = this.bannerList[0]
      return (banner && banner.imgUrl) ? banner.imgUrl : ''
    },
    /** 有除「全部」外的二级 Tab 时才展示分类栏 */
    showActivityTabs() {
      return this.activityTabList.length > 1
    },
    priceCompareMode() {
      return String(this.activityFeatureType) === '1'
    },
  },
  methods: {
    applyBannerData(bannerImg, themeColor, configColor) {
      if (!bannerImg) return
      this.bannerList = [{
        imgUrl: bannerImg,
        themeColor: themeColor || '',
        configColor: configColor || '',
      }]
      this.$nextTick(() => this.updateThemeColor(0))
    },
    updateThemeColor(index = 0) {
      if (!this.bannerList || this.bannerList.length === 0) return
      const banner = this.bannerList[index] || this.bannerList[0]
      this.themeColor = (banner && (banner.configColor || banner.themeColor)) || ''
    },
    loadActivityMeta() {
      if (!this.activityId) {
        this.loadCategoryFallback()
        return
      }
      const form = {
        cardId: this.form.cardId,
        cityCode: this.form.cityCode,
        upgradeFlag: this.form.upgradeFlag,
        bathId: this.form.bathId,
        hotType: this.hotType,
        id: this.activityId,
        current: 1,
        size: 10,
      }
      this.$api
        .queryTopicBooleanAndCategory(form)
        .then((res) => {
          if (res.code !== 0 || !res.data) {
            this.loadCategoryFallback()
            return
          }
          const data = res.data
          this.activityFeatureType = data.activityFeatureType || '0'
          if (data.bannerImg) {
            this.applyBannerData(data.bannerImg, data.themeColor, data.configColor)
          } else if (data.configColor) {
            // 无列表顶图时仍可使用后台配置的主题色渲染分类 Tab
            this.themeColor = data.configColor
          }
          const showType = String(data.showType || this.showType)
          this.showType = showType
          if (showType === '2' && data.categoryList && data.categoryList.length > 0) {
            sessionStorage.setItem('lableCategoryList', JSON.stringify(data.categoryList))
            this.initWithCategoryData(data.categoryList)
          } else if (showType === '1') {
            this.resetCategoryFilter()
            this.loading = true
            this.getData()
          } else {
            this.loadCategoryFallback()
          }
        })
        .catch(() => {
          this.loadCategoryFallback()
        })
    },

    /**
     * 将活动分类树扁平化为二级 Tab（隐藏一级分类）
     * 每项携带 category1Id + category2Id，供查询时使用
     */
    buildFlatActivityTabs(categoryData) {
      const tabs = [{ id: '', name: '全部', category1Id: '', category2Id: '' }]
      const nameCount = {}

      ;(categoryData || []).forEach((cat1) => {
        ;(cat1.children || []).forEach((cat2) => {
          const baseName = cat2.name || ''
          nameCount[baseName] = (nameCount[baseName] || 0) + 1
        })
      })

      ;(categoryData || []).forEach((cat1) => {
        ;(cat1.children || []).forEach((cat2) => {
          let name = cat2.name || ''
          if (nameCount[name] > 1) {
            name = `${cat1.name}·${name}`
          }
          tabs.push({
            id: cat2.id,
            name,
            category1Id: cat1.id,
            category2Id: cat2.id,
          })
        })
      })

      return tabs
    },
    resetCategoryFilter() {
      this.form.category1Id = ''
      this.form.category2Id = ''
    },
    initWithCategoryData(categoryData) {
      this.activityTabList = this.buildFlatActivityTabs(categoryData)

      if (this.activityTabList.length <= 1) {
        this.resetCategoryFilter()
        this.loading = true
        this.getData()
        return
      }

      this.activeTabIndex = 0
      this.$nextTick(() => {
        if (this.$refs.secondTab) {
          this.$refs.secondTab.clickCard(0)
        } else {
          this.selectActivityTab(0, false)
        }
      })
    },
    scrollTo(index) {
      this.selectActivityTab(index, true)
    },
    selectActivityTab(index, scrollListTop = true) {
      const tab = this.activityTabList[index]
      if (!tab) return

      this.activeTabIndex = index
      this.form.category1Id = tab.category1Id || ''
      this.form.category2Id = tab.category2Id || ''
      this.form.current = 1
      this.finished = false
      this.loading2 = true
      this.list = []
      if (scrollListTop) {
        this.scrollToTop()
      }
      this.getData()
    },
    loadCategoryFallback() {
      const cached = sessionStorage.getItem('lableCategoryList')
      if (cached) {
        try {
          this.initWithCategoryData(JSON.parse(cached))
          return
        } catch (e) {
          // fall through
        }
      }
      this.fetchCategory()
    },
    fetchCategory() {
      this.$api
        .selectCategoryWithChildren(this.form.bathId, this.form.upgradeFlag, this.form.cityCode, 'MALL_GOODS')
        .then((res) => {
          if (res.code === 0 && res.data && res.data.length > 0) {
            sessionStorage.setItem('lableCategoryList', JSON.stringify(res.data))
            this.initWithCategoryData(res.data)
          } else {
            this.resetCategoryFilter()
            this.loading = true
            this.getData()
          }
        })
        .catch(() => {
          this.resetCategoryFilter()
          this.loading = true
          this.getData()
        })
    },

    setPrictType() {
      if (this.form.priceType) {
        this.form.priceType = this.form.priceType === '1' ? '0' : '1'
      } else {
        this.form.priceType = '1'
      }
      this.onRefresh()
    },
    setNomal() {
      this.form.priceType = null
      this.onRefresh()
    },

    getData() {
      this.form.bathId = this.form.bathId || localStorage.getItem('bathId')
      this.form.upgradeFlag = this.form.upgradeFlag || localStorage.getItem('upgradeFlag')
      this.form.id = this.activityId
      this.form.hotType = this.hotType

      // 首屏/切换 Tab/下拉刷新时，避免 list 为空误展示「暂无商品」
      if (this.form.current === 1 && !this.loading) {
        this.loading2 = true
      }

      this.$api
        .queryProductInfoHomeNew(this.form)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg)
            this.loading = false
            this.loading2 = false
            return
          }
          if (this.form.current == 1) {
            this.list = res.data.records
          } else {
            this.list.push(...res.data.records)
          }
          this.loading = false
          this.loading2 = false
          if (this.form.current >= res.data.pages) {
            this.finished = true
          }
        })
        .catch(() => {
          this.loading = false
          this.loading2 = false
        })
    },
    nextPage() {
      if (this.list.length >= 10) {
        this.loading = false
        this.form.current += 1
        this.getData()
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.form.current = 1
        this.finished = false
        this.list = []
        this.loading2 = true
        this.getData()
        this.isLoading = false
      }, 300)
    },

    initView() {
      if (this.dataLoaded) return
      this.dataLoaded = true

      this.activityId = this.$route.query.activityId || ''
      this.hotType = this.$route.query.type || 'B'
      this.showType = this.$route.query.showType || '1'

      this.form.cardId = localStorage.getItem('cardId')
      this.form.cityCode = localStorage.getItem('cityCode')
      this.form.upgradeFlag = localStorage.getItem('upgradeFlag')
      this.form.bathId = localStorage.getItem('bathId')
      this.form.current = 1
      this.resetCategoryFilter()
      this.activeTabIndex = 0
      this.list = []
      this.bannerList = []
      this.activityTabList = []
      this.themeColor = ''
      this.activityFeatureType = '0'
      this.finished = false
      this.loading = true
      this.loading2 = false

      this.loadActivityMeta()
    },

    handleScroll() {
      const scrollTop = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop
      this.showBackTop = scrollTop > 300
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeRouteEnter(to, from, next) {
    to.meta.keepAlive = true
    const isDetail = /^\/Details/i.test(from.path)
    if (!isDetail) {
      next((vm) => {
        vm.$nextTick(() => {
          vm.initView()
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
        })
      })
    } else {
      initViewfinish = true
      next()
    }
  },
  created() {
    if (initViewfinish) {
      initViewfinish = false
    }
  },
  watch: {
    '$route'(to, from) {
      const isFromDetail = /^\/Details/i.test(from.path)
      if (isFromDetail) return
      if (to.path === '/ActivityGoodsList') {
        this.dataLoaded = false
        this.$nextTick(() => this.initView())
      }
    },
  },
  activated() {
    if (!isPageViewRestorePending(PAGE_KEYS.ACTIVITY_GOODS_LIST)) return
    this.$nextTick(() => {
      restorePageViewState(PAGE_KEYS.ACTIVITY_GOODS_LIST, {
        [SECTION_KEYS.CATEGORY_TAB]: (left) => {
          if (this.$refs.secondTab) {
            this.$refs.secondTab.setNavScrollLeft(left)
          }
        },
      })
    })
  },
  beforeRouteLeave(to, from, next) {
    if (shouldPreserveViewState(to.path)) {
      savePageViewState(PAGE_KEYS.ACTIVITY_GOODS_LIST, {
        scrollTop: getWindowScrollTop(),
        sections: {
          [SECTION_KEYS.CATEGORY_TAB]: this.$refs.secondTab
            ? this.$refs.secondTab.getNavScrollLeft() : 0,
        },
      })
    } else {
      consumePageViewState(PAGE_KEYS.ACTIVITY_GOODS_LIST)
    }
    next()
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/goodslist.scss';

.activity-goods-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  transition: background-color 0.4s ease;

  &.has-theme {
    background-color: var(--activity-list-bg, #f5f5f5);
  }
}

.activity-sticky-bar {
  background-color: #fff;
}

.activity-list-body {
  position: relative;
  min-height: 50vh;
  padding: 0.5rem 0 3rem;
}

.activity-banner-section {
  position: relative;
  width: 100%;
  /* 有 banner 时固定 750:280，防止 van-image 加载中按原图高度撑开 */
  height: 37.333vw;
  max-height: 9.5rem;
  overflow: hidden;

  .activity-banner-img {
    width: 100%;
    height: 100%;
    display: block;

    :deep(.van-image) {
      width: 100%;
      height: 100%;
      display: block;
    }

    :deep(.van-image__img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    :deep(.van-image__loading),
    :deep(.van-image__error) {
      width: 100%;
      height: 100%;
    }
  }
}

.activity-theme-zone {
  transition: background 0.4s ease;

  &.has-theme {
    :deep(.second-tab-container-inner),
    :deep(.second-tab-row),
    :deep(.topNav2),
    :deep(.expand-btn) {
      background-color: transparent !important;
    }

    :deep(.expand-btn),
    :deep(.second-tab-wrapper) {
      border-color: rgba(255, 255, 255, 0.25) !important;
    }

    :deep(.expand-btn) {
      color: rgba(255, 255, 255, 0.9) !important;
    }

    :deep(.topNav2 .untitle-sty) {
      background-color: rgba(255, 255, 255, 0.22) !important;
      color: rgba(255, 255, 255, 0.92) !important;
    }

    :deep(.topNav2 .title-sty) {
      background-color: #fff !important;
      color: #333 !important;
    }
  }
}

.activity-flat-tabs.second-tab-wrapper {
  border-top: none;
}
</style>
